module.exports = __webpack_public_path__ + "img/Anglija.f063d7ab.png";